import { registerPlugin } from '@capacitor/core';

// Backed by a native Swift plugin on iOS only (see ios/App/App/ScreenSecurityPlugin.swift).
// Android doesn't need this — FLAG_SECURE (MainActivity.java) blocks recording
// outright, so there's nothing to detect. On web/Android this resolves to the
// inert `web` fallback below rather than throwing "not implemented".
const ScreenSecurity = registerPlugin('ScreenSecurity', {
  web: () => ({
    isCaptured: async () => ({ isCaptured: false }),
    addListener: () => ({ remove: () => {} }),
  }),
});

export default ScreenSecurity;
